import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProofBar() {
  const items = [{
    icon: <Users className="w-6 h-6" data-id="element-295" />,
    text: '+500 familias confían'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-296" />,
    text: '6 Tomos listos'
  }, {
    icon: <Gift className="w-6 h-6" data-id="element-297" />,
    text: '6 Bonos incluidos'
  }, {
    icon: <Star className="w-6 h-6 fill-brand-gold" data-id="element-298" />,
    text: '⭐ 4.9/5'
  }];
  return <div className="w-full bg-brand-card border-y border-white/5 py-6" data-id="element-299">
      <div className="max-w-6xl mx-auto px-4" data-id="element-300">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-301">
          {items.map((item, index) => <div key={index} className="flex flex-col items-center justify-center gap-2" data-id="element-302">
              <div className="text-brand-gold" data-id="element-303">{item.icon}</div>
              <span className="font-medium text-sm md:text-base text-gray-200" data-id="element-304">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}